import {
  ModalCloseButton,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import { CreateInvoiceArrivalRootScreenParamList } from "../../../../types";
import { InvoiceArrivalDetailsForm } from "../../components";
import { CreateInvoiceArrivalScreen } from "../CreateInvoiceArrivalScreen";
import { CardStyleInterpolators } from "@react-navigation/stack";
import { SelectLocationModalScreen } from "../../../../components/SelectLocationModalScreen";
import { SelectSupplierModalScreen } from "../../../../components/SelectSupplierModalScreen";

export const CreateInvoiceArrivalRootScreen = () => {
  const Drawer =
    createStackHeaderNavigator<CreateInvoiceArrivalRootScreenParamList>();

  return (
    <InvoiceArrivalDetailsForm.Provider
      defaultFormValues={{
        costPriceIncGST: true,
        freightCost: "0",
      }}
    >
      <Drawer.Navigator
        screenOptions={{
          title: "",
          animationEnabled: true,
          headerLeft: () => <ModalCloseButton type="Cancel" />,
        }}
      >
        <Drawer.Screen
          name="CreateInvoiceArrivalScreen"
          component={CreateInvoiceArrivalScreen}
        />

        <Drawer.Group
          screenOptions={{
            cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
          }}
        >
          <Drawer.Screen
            name="SelectLocationModalScreen"
            component={SelectLocationModalScreen}
          />
          <Drawer.Screen
            name="SelectSupplierModalScreen"
            component={SelectSupplierModalScreen}
          />
        </Drawer.Group>
      </Drawer.Navigator>
    </InvoiceArrivalDetailsForm.Provider>
  );
};
